import { Control, useFieldArray, useWatch } from 'react-hook-form';
import {
  StyleProp,
  StyleSheet,
  TextStyle,
  View,
  ViewStyle,
} from 'react-native';
import { CheckboxOption as CropCircleCheckboxOption } from '../crop-circle/Components/CheckboxOption';
import { spacing } from '../crop-circle/tokens';

type CheckboxOption = {
  value: string;
  label?: string;
};

type ControlledCheckboxItemProps = {
  name: string;
  control: Control;
  options: CheckboxOption[];
  position: 'leading' | 'trailing';
  style?: StyleProp<ViewStyle>;
  labelStyle?: StyleProp<TextStyle>;
  mode?: 'android' | 'ios';
  color?: string;
  disabled?: boolean;
};

export const ControlledCheckboxItems = (props: ControlledCheckboxItemProps) => {
  const { append, remove } = useFieldArray({
    name: props.name,
    control: props.control,
  });
  const values = useWatch({
    name: props.name,
    control: props.control,
  });

  const onChange = (value: string) => {
    if (values?.includes(value)) {
      remove(values.indexOf(value));
    } else {
      append(value);
    }
  };

  return (
    <View style={styles.container}>
      {props.options.map((option) => (
        <CropCircleCheckboxOption
          key={option.value}
          mode="checkbox"
          state={values?.includes(option.value) ? 'checked' : 'unchecked'}
          label={option.label || option.value}
          onPress={() => onChange(option.value)}
          disabled={props.disabled}
        />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    gap: spacing.sm,
  },
});
